<button
  type="button"
  [routerLink]="getRouterLink() | async"
  class="btn btn-outline-primary ms-2"
>
  {{ 'CANCEL' | translate }}
</button>
